import Fetch from 'lib/store/middleware/api/fetch/Fetch';

const fetch = new Fetch();

// INTERCEPTORS DEPRECATED, USE THE MOCK API INSTEAD
// mocking-requests.md
// -------------------------------------------------

export default (...args) => fetch.fetch(...args);
